import React from "react"
import { Text } from "@chakra-ui/react"

type Props = {
  email?: string;
  emailHardBounced?: boolean;
  emailSoftBounced?: boolean;
}

const EmailValidityCell = ({ email, emailHardBounced, emailSoftBounced }: Props) => {
  if (!email) return null

  let status = "Valid"
  let color = "green.500"

  if (emailHardBounced) {
    status = "Hard Bounced"
    color = "red.500"
  } else if (emailSoftBounced) {
    status = "Soft Bounced"
    color = "orange.500"
  }

  return (
    <Text fontSize="sm" color={color} noOfLines={1}>
      {status}
    </Text>
  )
}

export default EmailValidityCell
